'use strict';

exports.__esModule = true;
exports.Cursor = exports.mapUUIDs = exports.Frame = exports.QUERY_SEP = exports.FRAME_SEP = exports.UUID_ATOM_SEP = exports.FLOAT_ATOM_SEP = exports.INT_ATOM_SEP = exports.QUERY_ATOM = exports.FRAME_ATOM = exports.UUID_SEPS = exports.REDEF_SEPS = exports.PARSE_ERROR = exports.END = exports.ZERO = exports.VALUE_RE = exports.RE = exports.Batch = exports.UUID_ERROR = exports.UUID = undefined;

var _ronUuid = require('@swarm/ron-uuid');

Object.defineProperty(exports, 'UUID', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ronUuid).default;
  }
});
Object.defineProperty(exports, 'UUID_ERROR', {
  enumerable: true,
  get: function get() {
    return _ronUuid.ERROR;
  }
});

var _batch = require('./batch');

Object.defineProperty(exports, 'Batch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_batch).default;
  }
});
exports.ron2js = ron2js;
exports.js2ron = js2ron;
exports.slice = slice;

var _ronGrammar = require('@swarm/ron-grammar');

var _ronGrammar2 = _interopRequireDefault(_ronGrammar);

var _ronUuid2 = _interopRequireDefault(_ronUuid);

var _batch2 = _interopRequireDefault(_batch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TRUE_UUID = _ronUuid2.default.fromString('true');
var FALSE_UUID = _ronUuid2.default.fromString('false');
var NULL_UUID = _ronUuid2.default.fromString('0');

// A RON op object. Typically, an Op is hosted in a frame.
// Frames are strings, so Op is sort of a Frame iterator.

var Op = function () {
  function Op(type, object, event, location, values, term) {
    _classCallCheck(this, Op);

    this.type = type;
    this.object = object;
    this.event = event;
    this.location = location;
    this.values = values || '';
    this.parsed_values = undefined;

    this.term = term || ';';
    this.source = null; // FIXME remove
    return this;
  }

  Op.prototype.value = function value(i) {
    if (!this.parsed_values) this.parsed_values = ron2js(this.values);
    return this.parsed_values[i];
  };

  Op.prototype.isHeader = function isHeader() {
    return this.term === '!';
  };

  Op.prototype.isQuery = function isQuery() {
    return this.term === '?';
  };

  Op.prototype.isRegular = function isRegular() {
    return !this.isHeader() && !this.isQuery();
  };

  Op.prototype.isError = function isError() {
    return this.event.value === _ronUuid.ERROR.value;
  };

  Op.prototype.isComment = function isComment() {
    return this.type.eq(_ronUuid.COMMENT);
  };

  // Get op UUID by index (0-3)


  Op.prototype.uuid = function uuid(i) {
    switch (i) {
      case 0:
        return this.type;
      case 1:
        return this.object;
      case 2:
        return this.event;
      case 3:
        return this.location;
      default:
        throw new Error('incorrect uuid index');
    }
  };

  Op.prototype.key = function key() {
    return '*' + this.type.value + '#' + this.object.value;
  };

  Op.prototype.toString = function toString(ctxOp) {
    var ret = '';
    var ctx = ctxOp || ZERO;
    var expComma = ctx.term !== ';';

    var _arr = [0, 1, 2, 3];
    for (var _i = 0; _i < _arr.length; _i++) {
      var u = _arr[_i];
      var uuid = this.uuid(u);
      var same = ctx.uuid(u);
      if (uuid.eq(same)) continue;
      var str = uuid.toString(same);
      ret += UUID_SEPS[u];
      ret += str;
    }

    ret += this.values;
    if (!this.values || expComma && this.term !== ',' || !expComma && this.term !== ';') {
      ret += this.term;
    }
    return ret;
  };

  Op.prototype.clone = function clone() {
    return new Op(this.type, this.object, this.event, this.location, this.values, this.term);
  };

  Op.prototype.equal = function equal(other) {
    return this.uuid(0).eq(other.uuid(0)) && this.uuid(1).eq(other.uuid(1)) && this.uuid(2).eq(other.uuid(2)) && this.uuid(3).eq(other.uuid(3)) && this.values === other.values && this.term === other.term;
  };

  Op.fromString = function fromString(body, context, offset) {
    var ctx = context || ZERO;
    var off = offset || 0;
    RE.lastIndex = off;
    var m = RE.exec(body);
    if (!m || m[0] === '' || m.index !== off) return null;
    if (m[1] === _ronUuid.COMMENT.value) ctx = ZERO;
    var term = m[6];
    if (!term) {
      if (ctx.term === '!') {
        term = ',';
      } else {
        term = ctx.term;
      }
    }

    var ret = new Op(_ronUuid2.default.fromString(m[1], ctx.type), _ronUuid2.default.fromString(m[2], ctx.object), _ronUuid2.default.fromString(m[3], ctx.event), _ronUuid2.default.fromString(m[4], ctx.location), m[5], term);
    ret.source = m[0];
    return ret;
  };

  return Op;
}();

// Parse RON value atoms.


exports.default = Op;
function ron2js(values) {
  VALUE_RE.lastIndex = 0;
  var m = void 0;
  var ret = [];

  while (m = VALUE_RE.exec(values)) {
    if (m[1]) {
      ret.push(parseInt(m[1]));
    } else if (m[2]) {
      ret.push(JSON.parse('"' + m[2] + '"')); // VALUE_RE returns match w/o single quotes
    } else if (m[3]) {
      ret.push(parseFloat(m[3]));
    } else if (m[4]) {
      switch (m[4]) {
        case TRUE_UUID.value:
          ret.push(true);
          break;
        case FALSE_UUID.value:
          ret.push(false);
          break;
        case NULL_UUID.value:
          ret.push(null);
          break;
        default:
          ret.push(_ronUuid2.default.fromString(m[4]));
      }
    }
  }
  return ret;
}

// Serialize JS primitives into RON atoms.
function js2ron(values) {
  var ret = values.map(function (v) {
    if (v === undefined) return UUID_ATOM_SEP + _ronUuid.ZERO.toString();
    if (v === null) return UUID_ATOM_SEP + NULL_UUID.toString();

    switch (v.constructor) {
      case String:
        var json = JSON.stringify(v);
        var escq = json.replace(/'/g, '\\u0027');
        return "'" + escq.substr(1, escq.length - 2) + "'";
      case Number:
        return Number.isInteger(v) ? INT_ATOM_SEP + v.toString() : FLOAT_ATOM_SEP + v.toString();
      case _ronUuid2.default:
        return UUID_ATOM_SEP + v.toString();
      case Boolean:
        return UUID_ATOM_SEP + (v ? TRUE_UUID : FALSE_UUID).toString();
      default:
        if (v === Op.FRAME_ATOM) return FRAME_SEP;
        if (v === Op.QUERY_ATOM) return QUERY_SEP;
        throw new Error('unsupported type');
    }
  });
  return ret.join('');
}

var RE = exports.RE = new RegExp(_ronGrammar2.default.OP.source, 'g');
var VALUE_RE = exports.VALUE_RE = new RegExp(_ronGrammar2.default.ATOM.source, 'g');
var ZERO = exports.ZERO = new Op(_ronUuid.ZERO, _ronUuid.ZERO, _ronUuid.ZERO, _ronUuid.ZERO, '>0');

var END = exports.END = new Op(_ronUuid.ERROR, _ronUuid.ERROR, _ronUuid.ERROR, _ronUuid.ERROR, '>~');
var PARSE_ERROR = exports.PARSE_ERROR = new Op(_ronUuid.ERROR, _ronUuid.ERROR, _ronUuid.ERROR, _ronUuid.ERROR, '>parseerror');
var REDEF_SEPS = exports.REDEF_SEPS = '`';
var UUID_SEPS = exports.UUID_SEPS = '*#@:';
var FRAME_ATOM = exports.FRAME_ATOM = Symbol('FRAME');
var QUERY_ATOM = exports.QUERY_ATOM = Symbol('QUERY');
var INT_ATOM_SEP = exports.INT_ATOM_SEP = '=';
var FLOAT_ATOM_SEP = exports.FLOAT_ATOM_SEP = '^';
var UUID_ATOM_SEP = exports.UUID_ATOM_SEP = '>';
var FRAME_SEP = exports.FRAME_SEP = '!';
var QUERY_SEP = exports.QUERY_SEP = '?';

var Frame = exports.Frame = function () {
  function Frame(str) {
    _classCallCheck(this, Frame);

    this.body = str ? str.toString() : '';
    this.last = ZERO;
    return this;
  }

  // Append a new op to the frame


  Frame.prototype.push = function push(op) {
    if (this.last.isComment()) {
      this.last = ZERO;
    }

    this.body += op.toString(this.last);
    this.last = op;
  };

  Frame.prototype.pushWithTerm = function pushWithTerm(op, term) {
    if (this.last.isComment()) {
      this.last = ZERO;
    }

    var clone = op.clone();
    clone.term = term;

    this.body += clone.toString(this.last);
    this.last = clone;
  };

  /*:: @@iterator(): Iterator<Op> { return ({}: any); } */

  // $FlowFixMe - computed property


  Frame.prototype[Symbol.iterator] = function () {
    return new Cursor(this.body);
  };

  Frame.prototype.toString = function toString() {
    return this.body;
  };

  Frame.prototype.mapUUIDs = function mapUUIDs(fn) {
    this.body = _mapUUIDs(this.body, fn);
    for (var _iterator = this, _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i2 >= _iterator.length) break;
        _ref = _iterator[_i2++];
      } else {
        _i2 = _iterator.next();
        if (_i2.done) break;
        _ref = _i2.value;
      }

      var op = _ref;

      this.last = op;
    }
  };

  Frame.prototype.equal = function equal(other) {
    if (this.toString() === other.toString()) return true;
    var cursor = new Cursor(other.toString());
    for (var _iterator2 = this, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i3 >= _iterator2.length) break;
        _ref2 = _iterator2[_i3++];
      } else {
        _i3 = _iterator2.next();
        if (_i3.done) break;
        _ref2 = _i3.value;
      }

      var op = _ref2;

      var oop = cursor.op;
      if (!oop || !op.equal(oop)) return false;
      cursor.next();
    }
    return cursor.next().done;
  };

  Frame.prototype.isFullState = function isFullState() {
    for (var _iterator3 = this, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray3) {
        if (_i4 >= _iterator3.length) break;
        _ref3 = _iterator3[_i4++];
      } else {
        _i4 = _iterator3.next();
        if (_i4.done) break;
        _ref3 = _i4.value;
      }

      var op = _ref3;
      return op.isHeader() && op.uuid(3).isZero();
    }return false;
  };

  Frame.prototype.isPayload = function isPayload() {
    for (var _iterator4 = this, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray4) {
        if (_i5 >= _iterator4.length) break;
        _ref4 = _iterator4[_i5++];
      } else {
        _i5 = _iterator4.next();
        if (_i5.done) break;
        _ref4 = _i5.value;
      }

      var op = _ref4;
      if (op.isRegular()) return true;
    }return false;
  };

  Frame.prototype.filter = function filter(p) {
    var ret = new Frame();
    for (var _iterator5 = this, _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray5) {
        if (_i6 >= _iterator5.length) break;
        _ref5 = _iterator5[_i6++];
      } else {
        _i6 = _iterator5.next();
        if (_i6.done) break;
        _ref5 = _i6.value;
      }

      var op = _ref5;
      if (p(op)) ret.push(op);
    }return ret;
  };

  Frame.prototype.ID = function ID() {
    for (var _iterator6 = this, _isArray6 = Array.isArray(_iterator6), _i7 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
      var _ref6;

      if (_isArray6) {
        if (_i7 >= _iterator6.length) break;
        _ref6 = _iterator6[_i7++];
      } else {
        _i7 = _iterator6.next();
        if (_i7.done) break;
        _ref6 = _i7.value;
      }

      var op = _ref6;
      return op.uuid(1);
    }return _ronUuid.ZERO;
  };

  Frame.prototype.unzip = function unzip() {
    var cumul = [];
    for (var _iterator7 = this, _isArray7 = Array.isArray(_iterator7), _i8 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
      var _ref7;

      if (_isArray7) {
        if (_i8 >= _iterator7.length) break;
        _ref7 = _iterator7[_i8++];
      } else {
        _i8 = _iterator7.next();
        if (_i8.done) break;
        _ref7 = _i8.value;
      }

      var op = _ref7;
      cumul.push(op);
    }return cumul;
  };

  return Frame;
}();

// Substitute UUIDs in all of the frame's ops.
// Typically used for macro expansion.


function _mapUUIDs(rawFrame, fn) {
  var ret = new Frame();
  var index = -1;
  for (var _iterator8 = new Frame(rawFrame), _isArray8 = Array.isArray(_iterator8), _i9 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
    var _ref8;

    if (_isArray8) {
      if (_i9 >= _iterator8.length) break;
      _ref8 = _iterator8[_i9++];
    } else {
      _i9 = _iterator8.next();
      if (_i9.done) break;
      _ref8 = _i9.value;
    }

    var op = _ref8;

    index++;
    ret.push(new Op(fn(op.type, 0, index, op) || op.type, fn(op.object, 1, index, op) || op.object, fn(op.event, 2, index, op) || op.event, fn(op.location, 3, index, op) || op.location, op.values, op.term));
  }
  return ret.toString();
}

// Crop a frame, i.e. make a new [from,till) frame
exports.mapUUIDs = _mapUUIDs;
function slice(from, till) {
  if (!from.op) return '';
  if (from.body !== till.body) throw new Error('iterators of different frames');
  var ret = from.op.toString();
  ret += from.body.substring(from.offset + from.length, till.op ? till.offset : undefined);
  return ret;
}

var Cursor = exports.Cursor = function () {
  function Cursor(body) {
    _classCallCheck(this, Cursor);

    this.body = body ? body.toString().trim() : '';
    this.offset = 0;
    this.length = 0;
    this.op = this.nextOp();
    return this;
  }

  Cursor.prototype.toString = function toString() {
    return this.body;
  };

  Cursor.prototype.clone = function clone() {
    var ret = new Cursor(this.body);
    ret.offset = this.offset;
    ret.length = this.length;
    ret.op = this.op;
    ret.ctx = this.ctx;
    return ret;
  };

  Cursor.prototype.nextOp = function nextOp() {
    this.offset += this.length;
    if (this.offset === this.body.length) {
      this.op = null;
      this.length = 1;
    } else {
      var op = Op.fromString(this.body, this.ctx, this.offset);
      this.ctx = op;
      if (op) {
        if (op.isComment()) this.ctx = ZERO;
        if (op.source) this.length = op.source.length;
      }
      this.op = op;
    }
    return this.op;
  };

  Cursor.prototype.eof = function eof() {
    return !this.op;
  };

  /*:: @@iterator(): Iterator<Op> { return ({}: any); } */

  // $FlowFixMe - computed property


  Cursor.prototype[Symbol.iterator] = function () {
    return this;
  };

  Cursor.prototype.next = function next() {
    var ret = this.op;
    if (ret) {
      this.nextOp();
      return { done: false, value: ret };
    } else {
      return { done: true };
    }
  };

  return Cursor;
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/ron/lib/index.js
// module id = 3
// module chunks = 0